import React, { useEffect, useRef, useState } from "react"
import { updateToastData } from "../../../slices/toastSlice"
import { TOAST_SEVERITY_ERROR } from "../../../components/core/Toast/Toast"
import Axios from "../../../Util/Axios"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import ImageIcon from "@mui/icons-material/Image"
import "./CustomOrderChat.css"
import Box from "@mui/material/Box"
import SendIcon from "@mui/icons-material/Send"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import Button from "@mui/material/Button"
import ClearIcon from "@mui/icons-material/Clear"
import { createFilePreview } from "../../../Util/Util"

const CustomOrderChat = ({ orderData, isStaff, senderEmail }) => {
  const messages = orderData?.messages || []
  const [loading, setLoading] = useState(false)
  const [messageText, setMessageText] = useState("")
  const [files, setFiles] = useState([])
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const messageEndRef = useRef(null)
  const [chatopen, setChatopen] = useState(false)
  const fileUploadRef = useRef(null)
  const chatBoxRef = useRef(null)

  useEffect(() => {
    if (messageEndRef?.current) {
      setTimeout(() => {
        messageEndRef.current?.scrollIntoView({
          behavior: "instant",
          block: "center",
        })
      }, 100)
    }
  }, [messages, chatopen])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatBoxRef?.current && !chatBoxRef.current.contains(event.target)) {
        setChatopen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const sendMessage = () => {
    if (loading) {
      return
    }
    if (!messageText && !files.length) {
      dispatch(
        updateToastData({
          message: "Message cannot be empty",
          severity: TOAST_SEVERITY_ERROR,
        })
      )
      return
    }
    let url = `/api/order-detail/${orderData.customer_facing_id}/action_send_message/`
    if (isStaff) {
      url = `/api/staff-order-detail/${orderData.customer_facing_id}/action_send_message/`
    }
    setLoading(true)
    // const data = {
    //   text: text,
    //   sender_email: senderEmail,
    // }

    // Create a FormData instance
    let formData = new FormData()

    // Append all files to the formData object
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i].file)
    }

    formData.append("text", messageText)
    formData.append("sender_email", senderEmail)

    Axios.post(url, formData, navigate)
      .then(({ data }) => {
        orderData.messages = data.messages
        setLoading(false)
        setMessageText("")
        setFiles([])
      })
      .catch((e) => {
        setLoading(false)
        dispatch(
          updateToastData({
            message: "Error Sending Message",
            severity: TOAST_SEVERITY_ERROR,
          })
        )
      })
  }

  let hide = {
    display: "none",
  }
  let show = {
    display: "block",
  }

  const toggle = (e) => {
    setChatopen(!chatopen)
  }

  return (
    <div id="chatCon" ref={chatBoxRef}>
      <div className="chat-box" style={chatopen ? show : hide}>
        <div className="header">
          <img
            height={20}
            src="https://marlinsurf-assets.s3.us-west-1.amazonaws.com/marlinmedium.png"
            className="App-logo"
            alt="logo"
          />{" "}
          Order #{orderData?.customer_facing_id}
          <Box>
            <Typography
              style={{
                fontFamily: "Josefin Sans",
              }}
              variant="caption"
            >
              Add images and ask me questions here
            </Typography>
          </Box>
        </div>
        <div className="msg-area">
          {messages.map((message) => {
            let alignRight =
              (isStaff && message.staff_member) ||
              (!isStaff && !message.staff_member)

            let className = "left"
            if (alignRight) {
              className = "right"
            }
            let messageAttachments = message.message_attachments || []
            return (
              <div key={message.id} ref={messageEndRef} className={className}>
                {message.text && <span>{message.text}</span>}

                {messageAttachments.map((messageAttachment) => {
                  return (
                    <div
                      key={messageAttachment.id}
                      style={{
                        paddingTop: message.text ? 10 : 0,
                      }}
                    >
                      <a href={messageAttachment.url} download target="_blank">
                        <img
                          style={{
                            width: 150,
                          }}
                          src={messageAttachment.url}
                        />
                      </a>
                    </div>
                  )
                })}
              </div>
            )
          })}
          <div ref={messageEndRef}></div>
          {!senderEmail && chatopen && (
            <Typography
              variant="body1"
              color="error"
              style={{
                fontFamily: "Josefin Sans",
              }}
            >
              Please enter your email to use chat.
            </Typography>
          )}
        </div>

        <div className="file-previews">
          {files.map((fileObj, i) => (
            <div key={i} className="file-preview">
              <img src={fileObj.preview} alt="File preview" />

              <IconButton
                component={Button}
                disabled={loading}
                style={{
                  color: "#fc3158",
                }}
                onClick={() => {
                  // Remove the file from the array
                  setFiles(files.filter((_, index) => index !== i))
                }}
              >
                <ClearIcon />
              </IconButton>
            </div>
          ))}
        </div>

        <div
          className="footer"
          onKeyDown={(event) => {
            if (event.key === "Enter" && senderEmail) {
              sendMessage()
            }
          }}
        >
          <input
            style={{ display: "none" }}
            ref={fileUploadRef}
            type="file"
            multiple
            disabled={!senderEmail}
            onChange={(event) => {
              const newFiles = Array.from(event.target.files)
              Promise.all(newFiles.map(createFilePreview)).then((previews) => {
                setFiles(
                  files.concat(
                    newFiles.map((file, i) => ({
                      file,
                      preview: previews[i],
                    }))
                  )
                )
              })
            }}
          />
          <IconButton
            component={Button}
            disabled={!senderEmail || loading}
            style={{
              color: loading ? "#8e8e93" : "#5fc9f8",
            }}
            onClick={() => {
              if (senderEmail) {
                fileUploadRef.current.click()
              }
            }}
          >
            <ImageIcon />
          </IconButton>
          <input
            type="text"
            value={messageText}
            disabled={!senderEmail}
            onChange={(event) => {
              if (!loading && senderEmail) {
                setMessageText(event.target.value)
              }
            }}
          />
          <IconButton
            style={{
              color: loading ? "#8e8e93" : "#147efb",
            }}
            component={Button}
            disabled={!senderEmail || loading}
            onClick={() => {
              if (senderEmail) {
                sendMessage()
              }
            }}
          >
            <SendIcon />
          </IconButton>
        </div>
      </div>

      <div className="pop">
        <p>
          <img
            style={{
              width: 65,
            }}
            onClick={toggle}
            src="https://marlinsurf-assets.s3.us-west-1.amazonaws.com/chatbigger.png"
            alt="Chat Icon"
          />
        </p>
      </div>
    </div>
  )
}

export default CustomOrderChat
